import { EMPTY_STRING } from '../../../constants/common'
import { getItemsIds } from '../../../utils/common'
import { isFormFieldsWithFilesEqual } from '../../../utils/formHelpers'
import {
  hasTinyMceHtmlVisibleContent,
  normalizeHtml,
} from '../../../utils/html'
import {
  CHATROOM_INPUT_FIELD_NAME_MESSAGE,
  CHATROOM_INPUT_INITIAL_VALUES,
} from '../Chatroom.constants'

export function getChatroomMessageEditInitialValues(message) {
  return {
    ...CHATROOM_INPUT_INITIAL_VALUES,
    [CHATROOM_INPUT_FIELD_NAME_MESSAGE]: message?.text || EMPTY_STRING,
  }
}

export function getChatroomMessageEditPayload({ files, text }) {
  return {
    files: getItemsIds(files),
    text,
  }
}

// TinyMCE re-serializes the loaded HTML, so both sides are normalized before
// the comparison — otherwise an untouched message would count as changed.
export function isChatroomMessageEditChanged({
  files,
  initialFiles,
  initialText,
  text,
}) {
  return !isFormFieldsWithFilesEqual({
    files,
    initialFiles,
    initialValues: { text: normalizeHtml(initialText || EMPTY_STRING) },
    values: { text: normalizeHtml(text || EMPTY_STRING) },
  })
}

export function isChatroomMessageEditEmpty({ files, text }) {
  return !hasTinyMceHtmlVisibleContent(text) && files.length === 0
}

export function getChatroomMessageEditIsSaveDisabled({
  filesUploading,
  isChanged,
  isSubmitting,
}) {
  return isSubmitting || filesUploading.length > 0 || !isChanged
}
